import React from "react";
import { Card, Row, Col } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
  Pie,
  PieChart,
} from "recharts";

function ReporCharts({ data, pieData }) {
  if (!data) {
    return null;
  } else if (data && data.length === 0) {
    return <Card>No data available</Card>;
  }

  const COLORS = ["#82ca9d", "#ff6961"];
  data = data?.sort((a, b) => b.call_count - a.call_count);

  return (
    <Card title="Orders by Data Source" bordered={false}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="source" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="success_count" fill="#82ca9d" />
              <Bar dataKey="failure_count" fill="#ff6961" />
            </BarChart>
          </ResponsiveContainer>
        </Col>
        <Col xs={24} md={12}>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                dataKey="value"
                startAngle={360}
                endAngle={0}
                data={pieData}
                outerRadius={80}
                fill="#8884d8"
                label={(entry) => `${entry.name} (${entry.value})`}
              >
                {pieData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </Col>
      </Row>
    </Card>
  );
}

export default ReporCharts;
